module.exports = __webpack_public_path__ + "static/media/dm.2910f70a.svg";